import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
/*models*/
import { IOrderHub } from '../../../../models/order';
import { IOrderStatuses } from '../../../../models/order-statuses';
import * as CON from '../../../common/constants';

/*CSS*/
import './order-tracker-styles.css';

interface ICategoryProps {
    state: IOrderStatuses;
    chevCatClass: (category: string) => string;
    warningDisplay: (category: string) => boolean;
    setPTagStyle: (category: string) => string;
    exceptionCheck: (category: string) => boolean;
    changeCategory: (category: string) => void;
    viewButtonCheck: (category: string) => boolean;
    currentEvent: IOrderHub;
    cancelled: boolean;
}

export const ProcessingCategory = ({
    state,
    chevCatClass,
    warningDisplay,
    setPTagStyle,
    exceptionCheck,
    changeCategory,
    viewButtonCheck,
    currentEvent,
    cancelled,
}: ICategoryProps) => {
    const intl = useIntl();
    return (
        <div
            className={chevCatClass(CON.PROCESSING)}
            id={state.processing.isActive ? 'processing-active' : 'processing'}
        >
            <div className="reRotate">
                <div>
                    {state.processing.isCompleted && !cancelled && (
                        <>
                            <i className="check-mark cp fas fa-check-circle fa-lg"></i>
                            <div className="my-secret-div"></div>
                        </>
                    )}
                    {warningDisplay(CON.PROCESSING) && (
                        <>
                            <i className="exclamation-1 ex-processing fas fa-exclamation-circle fa-lg"></i>
                            <div className="my-secret-div"></div>
                        </>
                    )}
                    <p className={setPTagStyle(CON.PROCESSING)}>
                        {intl.formatMessage({
                            id: CON.PROCESSING,
                            defaultMessage: CON.PROCESSING,
                        })}
                    </p>

                    <div className="completed-div">
                        {state.processing.isCompleted && !cancelled && (
                            <p
                                className={
                                    !state.processing.isActive
                                        ? 'p-no-margin blue'
                                        : 'p-no-margin'
                                }
                            >
                                {intl.formatMessage({
                                    id: CON.COMPLETED,
                                    defaultMessage: CON.COMPLETED,
                                })}
                            </p>
                        )}
                        {currentEvent.eventCatagory === CON.PROCESSING &&
                            currentEvent.exceptionLevel === '' &&
                            !cancelled && (
                                <p
                                    className={
                                        !state.processing.isActive
                                            ? 'p-no-margin blue'
                                            : 'p-no-margin'
                                    }
                                >
                                    {intl.formatMessage({
                                        id: CON.IN_PROGRESS_ID,
                                        defaultMessage: CON.IN_PROGRESS,
                                    })}
                                </p>
                            )}
                        {exceptionCheck(CON.PROCESSING) && (
                            <p
                                className={
                                    state.processing.exception1
                                        ? 'p-no-margin exception-1'
                                        : 'p-no-margin exception-2'
                                }
                            >
                                {intl.formatMessage({
                                    id: CON.EXCEPTION,
                                    defaultMessage: CON.EXCEPTION,
                                })}
                            </p>
                        )}
                        {currentEvent.eventCatagory === CON.PROCESSING &&
                            cancelled && (
                                <p className="p-no-margin exception-2">
                                    {intl.formatMessage({
                                        id: CON.CANCELLED,
                                        defaultMessage: CON.CANCELLED,
                                    })}
                                </p>
                            )}
                        {viewButtonCheck(CON.PROCESSING) && (
                            <button
                                className="delete-items-pad-left"
                                id="view-details-btn-processing"
                                onClick={() => {
                                    changeCategory(CON.PROCESSING);
                                }}
                            >
                                {intl.formatMessage({
                                    id: CON.VIEW_DETAIL_ID,
                                    defaultMessage: CON.VIEW_DETAIL,
                                })}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProcessingCategory;
